import { createSelector } from 'reselect';

const getWebConfig = state => state.settings.webConfiguretion;

export const getWebConfigSelector = createSelector(getWebConfig, webConfig => webConfig);
